import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule, NgZone } from '@angular/core';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MAT_SELECT_SCROLL_STRATEGY_PROVIDER } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { environment } from '@environments/environment';
import { ApiModule, ApiRequestManager } from '@sb/library/api';
import { BaseModule, DeviceTypeManager, DialogManager } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { CardModule } from '@sb/library/card';
import { DesignBlocksModule } from '@sb/library/design-blocks';
import { IconModule } from '@sb/library/icon';
import { IframeModule } from '@sb/library/iframe';
import { ImageModule } from '@sb/library/image';
import { LayoutModule } from '@sb/library/layout';
import { UtilityModule } from '@sb/library/utility';
import { WebsiteErrorManager, WebsiteLibraryModule } from '@sb/library/website';
import { WidgetErrorManager, WidgetManualDeviceTypeManager } from '@sb/library/widget';
import { ScaleImageUrlPipe } from '@shared/pipes/scale-image.pipe';
import { AppBootstrapService } from './app-bootstrap.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

const websiteDeviceTypeManagerFactory = (breakpointObserver: BreakpointObserver) => {
    if (document.getElementById('sb-bootstrap-websiteblock')) {
        return new WidgetManualDeviceTypeManager();
    } else {
        return new DeviceTypeManager(breakpointObserver);
    }
}

const websiteErrorManagerFactory = (ngZone: NgZone, dialogManager: DialogManager, apiRequestManager: ApiRequestManager) => {
    if (document.getElementById('sb-bootstrap-websiteblock')) {
        return new WidgetErrorManager(ngZone, dialogManager, apiRequestManager);
    } else {
        return new WebsiteErrorManager();
    }
}

@NgModule({
    declarations: [
        AppComponent,
        ScaleImageUrlPipe
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        LayoutModule,
        CommonModule,
        ButtonModule,
        RouterModule,
        BrowserAnimationsModule,
        IconModule,
        MatDialogModule,
        WebsiteLibraryModule,
        UtilityModule,
        ApiModule.setEnvironment(environment),
        DesignBlocksModule.setEnvironment(environment),
        CardModule,
        IframeModule,
        ImageModule,
        BaseModule,

        // Not sure why we have to do this, look at this later. https://github.com/angular/angular/issues/35759
        MatMenuModule,
        MatChipsModule,
        MatSnackBarModule
    ],
    providers: [
        AppBootstrapService.Provide(),
        MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER,
        MAT_SELECT_SCROLL_STRATEGY_PROVIDER,
        { provide: ErrorHandler, useFactory: websiteErrorManagerFactory, deps: [NgZone, DialogManager, ApiRequestManager] },
        { provide: DeviceTypeManager, useFactory: websiteDeviceTypeManagerFactory, deps: [BreakpointObserver] }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
